var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _rect4, _path7, _path8, _rect5, _rect6, _rect7, _path9, _path0, _ellipse, _ellipse2, _path1, _path10, _path11, _path12, _ellipse3, _path13, _path14, _path15, _ellipse4, _path16, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMolten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "m-glow1",
    cx: "72%",
    cy: "68%",
    r: "38%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6a00",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#c83200",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m-glow2",
    cx: "55%",
    cy: "78%",
    r: "22%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffaa00",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#c83200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m-glow3",
    cx: "88%",
    cy: "82%",
    r: "18%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff7700",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a02000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m-haze",
    cx: "50%",
    cy: "100%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff5500",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a0800",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "#0d0400"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#m-haze)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 500,
    fill: "#110600",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,200 Q80,220 140,160 Q200,100 260,180 Q320,250 400,140 Q480,30 560,120 Q620,180 680,90 Q750,0 820,80 Q900,160 960,40 Q1020,-20 1100,60 Q1180,130 1260,20 Q1340,-40 1400,50 Q1460,120 1520,30 L1600,0 Z",
    fill: "#0a0200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,30 Q60,80 120,40 Q180,0 240,60 Q300,120 380,50 Q440,0 500,70 Q560,130 640,60 Q700,10 760,80 Q820,140 900,50 Q960,-10 1040,40 Q1100,80 1160,20 Q1230,-20 1300,50 Q1360,110 1440,40 Q1500,0 1560,60 L1600,80 L1600,0 L0,0 Z",
    fill: "#1a0800",
    opacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200,0 Q210,180 240,200 Q260,210 270,180 Q280,140 310,0 Z",
    fill: "#0e0400"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M500,0 Q515,220 540,260 Q558,280 570,240 Q585,180 610,0 Z",
    fill: "#0e0400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M900,0 Q918,200 940,240 Q955,260 968,220 Q980,170 1010,0 Z",
    fill: "#0e0400"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1250,0 Q1268,160 1290,190 Q1305,210 1318,170 Q1330,120 1360,0 Z",
    fill: "#0e0400"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 420,
    height: 900,
    fill: "#060200",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,280 Q30,310 60,300 Q90,290 100,320 Q110,340 80,360 Q50,380 0,370 Z",
    fill: "#0a0300"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,500 Q40,480 70,510 Q100,530 80,560 Q60,590 0,580 Z",
    fill: "#080200"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#m-glow1)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#m-glow2)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#m-glow3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300,900 Q320,820 360,800 Q400,780 460,810 Q520,840 560,820 Q620,790 680,810 Q740,830 800,800 Q870,760 940,790 Q1000,820 1060,800 Q1130,770 1200,800 Q1260,820 1320,790 Q1380,760 1440,800 Q1480,820 1520,800 L1600,820 L1600,900 Z",
    fill: "#1c0800",
    opacity: 0.9
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0,840 Q80,810 160,830 Q240,850 320,820 Q400,790 480,820 Q540,840 600,810 Q680,770 760,800 Q840,830 920,800 Q1000,765 1080,800 Q1150,830 1220,800 Q1290,765 1380,810 Q1450,840 1530,820 L1600,830 L1600,900 L0,900 Z",
    fill: "#230e00"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860,
    cy: 810,
    rx: 320,
    ry: 40,
    fill: "#ff6a00",
    opacity: 0.28
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860,
    cy: 820,
    rx: 260,
    ry: 28,
    fill: "#ffaa00",
    opacity: 0.18
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M580,830 Q620,810 700,820 Q780,830 860,810 Q940,790 1020,815 Q1100,840 1140,830",
    stroke: "#ff8800",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.55
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M580,838 Q640,820 720,830 Q800,840 880,820 Q960,800 1040,822 Q1110,842 1140,836",
    stroke: "#ffcc00",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1100,870 Q1150,850 1220,858 Q1280,865 1340,848 Q1400,832 1460,850 L1600,860 L1600,900 L1100,900 Z",
    fill: "#2a1000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1100,878 Q1160,860 1230,868 Q1300,876 1360,856 Q1420,840 1470,858 L1600,868 L1600,900 L1100,900 Z",
    fill: "#1a0800"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1290,
    cy: 860,
    rx: 160,
    ry: 22,
    fill: "#ff7700",
    opacity: 0.22
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1210,878 Q1250,865 1290,872 Q1330,878 1370,863",
    stroke: "#ffaa44",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.45
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0,860 Q60,840 130,852 Q200,862 280,844 Q350,826 430,852 L430,900 L0,900 Z",
    fill: "#280e00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0,875 Q70,858 150,868 Q220,876 300,858 Q370,842 430,866 L430,900 L0,900 Z",
    fill: "#180600"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 868,
    rx: 160,
    ry: 20,
    fill: "#ff6600",
    opacity: 0.18
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80,880 Q130,866 200,872 Q260,878 320,862",
    stroke: "#ffaa44",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 740,
    r: 4,
    fill: "#ffdd88",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 700,
    r: 3,
    fill: "#ffcc66",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 860,
    cy: 720,
    r: 5,
    fill: "#ffaa44",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 680,
    r: 3,
    fill: "#ffdd88",
    opacity: 0.85
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 760,
    r: 4,
    fill: "#ff8844",
    opacity: 0.7
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 740,
    r: 3,
    fill: "#ffcc66",
    opacity: 0.75
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1050,
    cy: 700,
    r: 4,
    fill: "#ffaa44",
    opacity: 0.65
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 720,
    r: 2,
    fill: "#ffdd88",
    opacity: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 720,
    r: 3,
    fill: "#ff8844",
    opacity: 0.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 1200,
    cy: 760,
    r: 3,
    fill: "#ffcc66",
    opacity: 0.7
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 750,
    cy: 650,
    r: 2,
    fill: "#ffdd88",
    opacity: 0.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 660,
    r: 3,
    fill: "#ffaa44",
    opacity: 0.55
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 640,
    r: 2,
    fill: "#ffcc66",
    opacity: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 630,
    r: 2,
    fill: "#ff9944",
    opacity: 0.45
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1000,
    cy: 650,
    r: 2,
    fill: "#ffdd88",
    opacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 350,
    height: 900,
    fill: "#060200",
    opacity: 0.35
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 900,
    fill: "#060100",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolten);
export default __webpack_public_path__ + "static/media/molten.0023eec15e5dcee729f7f174e2cc9faa.svg";
export { ForwardRef as ReactComponent };